import { addScript } from '../../scripts';
import type { EventKey, TagConfig, TrackOpts } from './types';

const events: Record<EventKey, Record<string, unknown>> = {
  APPLICATION_SUBMIT: { conversion_id: 6764420 },
};

const defaultPartnerId = '7850';

interface LinTrk {
  (event: string, data: Record<string, unknown>): void;
  q: Array<[event: string, data: Record<string, unknown>]>;
}

declare global {
  interface Window {
    lintrk?: LinTrk;
    _linkedin_data_partner_ids?: Array<string>;
    GPC_DataSharingOptIn: boolean;
  }
}

export function init({ partnerId = defaultPartnerId, consent }: TagConfig) {
  if (window.lintrk || !(consent.Advertising && consent.Analytics) || !window.GPC_DataSharingOptIn) {
    return;
  }

  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(partnerId);

  const lintrk = <LinTrk>function (event: string, data: Record<string, unknown>) {
    window.lintrk?.q.push([event, data]);
  };
  lintrk.q = [];
  window.lintrk = lintrk;

  addScript({
    src: 'https://snap.licdn.com/li.lms-analytics/insight.min.js',
    crossOrigin: false,
  });
}

export function track({ event, consent }: TrackOpts) {
  if (!(consent.Advertising && consent.Analytics) || !window.GPC_DataSharingOptIn) {
    return;
  }

  if (window.lintrk) {
    window.lintrk('track', events[event]);
  }
}
